import React from 'react';

export const LandingPageSubjectSELSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="117"
    height="99"
    viewBox="0 0 117 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.76645 8.65102C20.3085 -2.8343 39.0272 -2.81958 50.5506 8.68423L58.3739 16.4958L61.3338 13.5885L62.0936 12.7711L62.1317 12.8053L66.3905 8.62466L66.9393 8.09927C78.5656 -2.7536 96.8173 -2.51645 108.154 8.76431C119.607 20.1612 119.716 38.5501 108.533 50.0797L107.991 50.6237L58.8016 98.8209L58.5946 98.611L58.3875 98.8209L8.92758 50.3541C-2.75238 38.9085 -2.82489 20.1856 8.76645 8.65102ZM46.2899 12.9098C37.1142 3.74999 22.2098 3.73735 13.0194 12.8825C3.78943 22.0671 3.8477 36.9767 13.1483 46.0905L58.5936 90.6247L103.772 46.359L104.203 45.9254C113.116 36.7361 113.029 22.0792 103.901 12.9958C94.8657 4.0051 80.3188 3.81672 71.0526 12.4665L70.6151 12.8854L65.659 17.7516L58.6776 25.276L46.2899 12.9098Z"
      fill="currentColor"
    />
  </svg>
);

export default LandingPageSubjectSELSvg;
